<template>
    <div class="vehicle-details">
        <aside-content-header :vehicle="currentJourney.vehicle" :is-hardware-online="isHardwareOnline"></aside-content-header>
        <div class="vehicle-details__content">
            <h3 class="vehicle-details__title">Vehicle Details</h3>
            <div class="vehicle-details__wrapper">
                <div class="vehicle-details__left">
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">VRN:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.registrationNumber || currentJourney.vehicle.vrn || 'Unknown' }}</div>
                    </div>
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">Type:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.type }}</div>
                    </div>
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">Fleet Name:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.fleetName }}</div>
                    </div>
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">Id:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.id }}</div>
                    </div>
                </div>
                <div class="vehicle-details__right">
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">Fuel:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.fuelType }}</div>
                    </div>
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">Engine Size:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.engineSize }}</div>
                    </div>
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">Model:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.model }}</div>
                    </div>
                </div>
            </div>
            <h3 class="vehicle-details__title vehicle-details__title--margin">Device</h3>
            <div class="vehicle-details__wrapper">
                <div class="vehicle-details__left">
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">Device Id:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.mediaHardwareId }}</div>
                    </div>
                </div>
                <div class="vehicle-details__right">
                    <div class="vehicle-details__item-wrapper">
                        <div class="vehicle-details__item-title">First Reported:</div>
                        <div class="vehicle-details__item">{{ currentJourney.vehicle.firstReported }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import AsideContentHeader from '@/views/Tracking/components/Aside/AsideContentHeader/AsideContentHeader'
import Journeys from '@/models/Journeys'

export default {
    name: "VehicleDetails",
    components: {
        AsideContentHeader
    },
    props: {
        currentJourney: {
            type: [Journeys, null],
            required: false
        },
        isHardwareOnline: {
            type: [Boolean],
            required: true
        }
    },
}
</script>

<style scoped lang="scss">

.vehicle-details {
    &__content {
        padding: 0 17px;
    }

    &__title {
        font-weight: 700;

        &--margin {
            margin-top: 20px;
        }
    }

    &__wrapper {
        display: flex;
        margin-top: 20px;
        border-bottom: 1px solid #e3e3e3;
    }

    &__left {
        display: flex;
        flex-direction: column;
        width: 42%;
    }

    &__right {
        display: flex;
        flex-direction: column;
        width: 42%;
        margin-left: auto;
    }

    &__item-wrapper {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        margin-bottom: 10px;
    }

    &__item-title {
        font-weight: 700;
    }

    &__item {

    }
}

</style>
